import React from 'react'

import '../stylesheets/components/Rich.scss'

export default class Rich extends React.Component {
    render() {
        return <div className="Rich" dangerouslySetInnerHTML={{ __html: this.props.children }} />
    }
}
